"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RequestAuthenticator {
    authenticate(request, token) {
        return {
            ...request,
            headers: {
                ...request.headers,
                Authorization: `Bearer ${token}`,
            },
        };
    }
}
exports.default = RequestAuthenticator;
//# sourceMappingURL=RequestAuthenticator.js.map